export default __webpack_public_path__ + "static/media/naga.ed0ffa6f.jpg";